import { Link } from "react-router-dom";
import AnimationOnScroll from "react-animate-on-scroll";
import "animate.css/animate.min.css";

import { ReactComponent as BackArrow } from "../assets/icons/BackArrow.svg";
import ButtonArrow from "../assets/images/button-arrow.svg";
import FaceDiagram from "../assets/images/face-diagram.svg";
import Respiratory from "../assets/images/respitary.svg";
import DryEye from "../assets/images/dry-eye.svg";
import Rhinitis from "../assets/images/Rhinitis.svg";
import Cognitive from "../assets/images/Cognitive.svg";
import DermaIcon from "../assets/icons/derma-icon.svg";
import ToothIcon from "../assets/images/tooth-icon.svg";

const Assessments = () => {
  return (
    <div className="bg-white px-6 pt-8 lg:pb-20 md:pb-20 pb-10 relative z-50 responsive-assment">
      <div className="tab-screen">
        <div className="mb-3 flex flex-row items-center text-black responsive-top-heading">
          <Link className="shrink-0 p-1 pr-2.5" to={-1}>
            <BackArrow className="h-4 w-4" />
          </Link>
          <h4 className="text-lg font-medium lg:text-2xl md:text-2xl text-black">
            All Assessments
          </h4>
        </div>

        <AnimationOnScroll animateIn="animate__fadeInUp" duration={0.65}>
          <div className="assessment-col bg-[#232831] rounded-[20px] px-5 pt-7 pb-4 relative flex flex-row justify-between">
            <div className="w-7/12">
              <h4 className="text-sm font-semibold text-white mb-3">
                <span className="from-[#41a0e1] via-[#41a0e1] to-[#fff] bg-gradient-to-r bg-clip-text text-transparent">
                  Face Scan
                </span>{" "}
                Health
                <br /> Risk Overview
              </h4>
              <p className="text-xxs text-white/70 leading-3 mb-3 pr-3">
                Gain insights into your cardiac health, physiological balance,
                autonomic strain, and diabetes risk.
              </p>
              <Link
                to="/start-scan"
                className="flex flex-row text-secondary items-center text-xxs font-semibold"
              >
                Take Assessment{" "}
                <img src={ButtonArrow} className="ml-2" alt="" />
              </Link>
            </div>
            <div className="w-5/12 flex justify-end responsive-facediagram">
              <img
                src={FaceDiagram}
                className="absolute right-5 h-[72%]"
                alt=""
              />
              <div className="card-circle-shadow"></div>
            </div>
          </div>
        </AnimationOnScroll>

        <div className="flex flex-row flex-wrap mt-3">
          <AnimationOnScroll
            className="w-6/12 xl:w-4/12 pr-1 mb-2 relative"
            animateIn="animate__fadeInUp"
            duration={0.65}
          >
            <div className="bg-[#232831] rounded-[20px] px-4 py-6 assesment-card">
              <div className="flex flex-row justify-between items-end mb-3 relative z-50">
                <h5 className="text-xxs text-white font-semibold leading-3">
                  <span className="from-[#41a0e1] to-[#fff] bg-gradient-to-r bg-clip-text text-transparent">
                    Respiratory
                  </span>
                  <br />
                  Health Check
                </h5>
                <img src={Respiratory} className="w-7 assessment-icon" alt="" />
              </div>

              <p className="text-[8px] text-white/70 leading-3 mb-2 pr-2 relative z-50">
                Assess airway function and identify early signs of obstructive
                airway disease for clearer breathing.
              </p>
              <Link
                to="/pulmo-dashboard"
                className="flex flex-row text-secondary items-center text-[9px] font-semibold"
              >
                Take Assessment{" "}
                <img src={ButtonArrow} className="ml-2" alt="" />
              </Link>
              <div className="circle-shadow top-0 right-0"></div>
            </div>
          </AnimationOnScroll>
          <AnimationOnScroll
            className="w-6/12 xl:w-4/12 pl-1 xl:pr-1 mb-2"
            animateIn="animate__fadeInUp"
            duration={0.65}
          >
            <div className="bg-[#232831] rounded-[20px] px-4 py-6 assesment-card">
              <div className="flex flex-row justify-between items-end mb-3 relative z-50">
                <h5 className="text-xxs text-white font-semibold leading-3">
                  <span className="from-[#41a0e1] to-[#fff] bg-gradient-to-r bg-clip-text text-transparent">
                    Dry-Eye
                  </span>
                  <br />
                  Risk Assessment
                </h5>
                <img src={DryEye} className="w-7 assessment-icon" alt="" />
              </div>

              <p className="text-[8px] text-white/70 leading-3 mb-2 pr-2 relative z-50">
                Evaluate tear film quality and ocular surface dryness to keep
                your eyes comfortable and healthy.
              </p>
              <Link
                to="/vision-instructions"
                className="flex flex-row text-secondary items-center text-[9px] font-semibold"
              >
                Take Assessment{" "}
                <img src={ButtonArrow} className="ml-2" alt="" />
              </Link>
            </div>
          </AnimationOnScroll>
          {/* <AnimationOnScroll
            className="w-6/12 xl:w-4/12 pr-1 xl:pr-0 xl:pl-1 pl-0"
            animateIn="animate__fadeInUp"
            duration={0.65}
          >
            <div className="bg-[#232831] rounded-[20px] px-4 py-6 assesment-card">
              <div className="flex flex-row justify-between items-end mb-3 relative z-50">
                <h5 className="text-xxs text-white font-semibold leading-3">
                  <span className="from-[#41a0e1] to-[#fff] bg-gradient-to-r bg-clip-text text-transparent">
                    Rhinitis
                  </span>
                  <br />
                  Risk Detection
                </h5>
                <img src={Rhinitis} className="w-7 assessment-icon" alt="" />
              </div>

              <p className="text-[8px] text-white/70 leading-3 mb-2 pr-2 relative z-50">
                Screen for nasal inflammation and allergy triggers to help you
                breathe easy.
              </p>
              <Link
                to="/allergy-dashboard"
                className="flex flex-row text-secondary items-center text-[9px] font-semibold"
              >
                Take Assessment{" "}
                <img src={ButtonArrow} className="ml-2" alt="" />
              </Link>
            </div>
          </AnimationOnScroll> */}
          <AnimationOnScroll
            className="w-6/12 pl-1 pr-1 xl:w-4/12 mb-2 relative xl:pl-1 xl:pr-1"
            animateIn="animate__fadeInUp"
            duration={0.65}
          >
            <div className="bg-[#232831] rounded-[20px] px-4 py-6 assesment-card">
              <div className="flex flex-row justify-between items-end mb-3 relative z-50">
                <h5 className="text-xxs text-white font-semibold leading-3">
                  <span className="from-[#41a0e1] to-[#fff] bg-gradient-to-r bg-clip-text text-transparent">
                    Cognitive
                  </span>
                  <br />
                  Balance Scan
                </h5>
                <img src={Cognitive} className="w-7 assessment-icon" alt="" />
              </div>

              <p className="text-[8px] text-white/70 leading-3 mb-2 pr-2 relative z-50">
                Measure mood stability and cognitive wellbeing to support your
                mental health journey.
              </p>
              <Link
                to=""
                className="flex flex-row text-secondary items-center text-[9px] font-semibold relative z-50"
              >
                Take Assessment{" "}
                <img src={ButtonArrow} className="ml-2" alt="" />
              </Link>
              <div className="circle-shadow bottom-0 left-0"></div>
            </div>
          </AnimationOnScroll>
          <AnimationOnScroll
            className="w-6/12 pr-1 pl-1 xl:w-4/12 mb-2 relative xl:pl-1"
            animateIn="animate__fadeInUp"
            duration={0.65}
          >
            <div className="bg-[#232831] rounded-[20px] px-4 py-6 assesment-card">
              <div className="flex flex-row justify-between items-end mb-3 relative z-50">
                <h5 className="text-xxs text-white font-semibold leading-3">
                  <span className="from-[#41a0e1] to-[#fff] bg-gradient-to-r bg-clip-text text-transparent">
                    Skin
                  </span>
                  <br />
                  Snapshot
                </h5>
                <img src={DermaIcon} className="w-7 assessment-icon" alt="" />
              </div>

              <p className="text-[8px] text-white/70 leading-3 mb-2 pr-2 relative z-50">
                Know your skin. Get expert insights and personalized care in
                minutes.
              </p>
              <Link
                to="/derma-start"
                className="flex flex-row text-secondary items-center text-[9px] font-semibold"
              >
                Take Assessment{" "}
                <img src={ButtonArrow} className="ml-2" alt="" />
              </Link>
              <div className="circle-shadow top-0 right-0"></div>
            </div>
          </AnimationOnScroll>
          <AnimationOnScroll
            className="w-6/12 pl-1 xl:w-4/12"
            animateIn="animate__fadeInUp"
            duration={0.65}
          >
            <div className="bg-[#232831] rounded-[20px] px-4 py-6 assesment-card">
              <div className="flex flex-row justify-between items-end mb-3 relative z-50">
                <h5 className="text-xxs text-white font-semibold leading-3">
                  <span className="from-[#41a0e1] to-[#fff] bg-gradient-to-r bg-clip-text text-transparent">
                    Dental
                  </span>
                  <br />
                  Risk Detection
                </h5>
                <img src={ToothIcon} className="w-7 assessment-icon" alt="" />
              </div>

              <p className="text-[8px] text-white/70 leading-3 mb-2 pr-2 relative z-50">
                Analyzing Oral Health Indicators for Early Risk Detection
              </p>
              <Link
                to="/dental-start"
                className="flex flex-row text-secondary items-center text-[9px] font-semibold"
              >
                Take Assessment
                <img src={ButtonArrow} className="ml-2" alt="" />
              </Link>
            </div>
          </AnimationOnScroll>
          <AnimationOnScroll
            className="w-6/12 pl-1 xl:w-4/12"
            animateIn="animate__fadeInUp"
            duration={0.65}
          >
            <div className="bg-[#232831] rounded-[20px] px-4 py-6 assesment-card">
              <div className="flex flex-row justify-between items-end mb-3 relative z-50">
                <h5 className="text-xxs text-white font-semibold leading-3">
                  <span className="from-[#41a0e1] to-[#fff] bg-gradient-to-r bg-clip-text text-transparent">
                    Facial
                  </span>
                  <br />
                  Analysis
                </h5>
                <img src={ToothIcon} className="w-7 assessment-icon" alt="" />
              </div>

              <p className="text-[8px] text-white/70 leading-3 mb-2 pr-2 relative z-50">
                Gain insights into your Heart Rate Respiration Rate Pulse
                Respiration Rate Facial Redness Dark Circles Eye Bags and Air
                Quality Index (AQI)
              </p>
              <Link
                to="/vital-scan-instructions"
                className="flex flex-row text-secondary items-center text-[9px] font-semibold"
              >
                Take Assessment
                <img src={ButtonArrow} className="ml-2" alt="" />
              </Link>
            </div>
          </AnimationOnScroll>
        </div>
      </div>
    </div>
  );
};

export default Assessments;
